import { render, staticRenderFns } from "./WorkIconPdf.vue?vue&type=template&id=ff947c46"
import script from "./WorkIconPdf.vue?vue&type=script&lang=js"
export * from "./WorkIconPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports